import { Box, Typography } from '@mui/material';
import LinkTile from '~/components/LinkTile';
import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import ReviewStatus from '~/components/Structures/ReviewStatus';
import { RigidRegistration } from '~/domain/patient/rigidRegistration';

export default function RegistrationRadioRow({
    reg,
    isSelected,
    onClick,
}: {
    reg: RigidRegistration;
    isSelected: boolean;
    onClick: () => void;
}) {
    return (
        <Box
            onClick={onClick}
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                height: 32,
                overflow: 'hidden',
                bgcolor: isSelected
                    ? 'rgba(144, 202, 249, 0.08)'
                    : 'transparent',
                '&:hover': {
                    bgcolor: isSelected
                        ? 'rgba(144, 202, 249, 0.12)'
                        : 'action.hover',
                },
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: 2,
                    bgcolor: isSelected ? 'primary.main' : 'transparent',
                    transition: 'background-color 0.15s ease-in-out',
                    zIndex: 1,
                },
                transition: 'all 0.15s ease-in-out',
            }}
        >
            <Box
                sx={{
                    width: 52,
                    height: '100%',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <LinkTile selected={isSelected} />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    minWidth: 0,
                    flex: 1,
                }}
            >
                <Typography
                    fontSize={11}
                    fontWeight={isSelected ? 500 : 400}
                    color={isSelected ? 'text.primary' : 'text.secondary'}
                    noWrap
                    sx={{ flex: 1, transition: 'color 0.15s ease-in-out' }}
                >
                    <SensitiveInfoTypography>
                        {reg.contentLabel || reg.sopInstanceUid}
                    </SensitiveInfoTypography>
                </Typography>
                <Box sx={{ flexShrink: 0, mr: 1 }}>
                    <ReviewStatus status={reg.approvalStatus} fontSize={11} />
                </Box>
            </Box>
        </Box>
    );
}
